import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";
import { connect } from "react-redux";
import { compose } from "redux";
import { Redirect } from "react-router-dom";

import { handleRadioChange } from "../DownloadAndDelete/actions";
import { setA11yContent } from "../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { media, isMobile } from "utils/style";
import Alert from "common-components/Alert";
import Button from "common-components/Buttons";
import CommonContainer from "common-components/Container";
// import { Radio } from "common-components/FormContent";
import FetchPageContent from "../../../hoc/FetchPageContent";
import { createUpdateProfile, createFileFormat } from "./actions/commonFormerCustomerAPI";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import { TitleLockup } from "@vds/type-lockups";
import { RadioButton } from "@vds/radio-buttons";
class FileFormatSelection extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("File format selection", this.props.pageContent.sc_pagetitle);
    }
  }

  handleSubmit = e => {

    const { location, uuid } = this.props

    var datas = {
      emailId: location.state.data.emailId,
      firstName: location.state.data.fname,
      lastName: location.state.data.lname,
      fileFormat: this.props.location.state.data.serviceType === "former" ? this.props.formerFileFormat :  this.props.fileFormat,
      action: location.state.data.currentIntent,
      flow: "fileFormatSelection",
      uuid: uuid,
      serviceType: location.state.data.serviceType,
      formerId: this.props.formerId,
      accountId: this.props.accountInfo
    }

    this.props.createUpdateProfile(datas).then(() => {
      if (!this.props.error) {
        var fileFormatData = {
          caseId: this.props.caseId,
          email: location.state.data.emailId,
          fileFormat: this.props.location.state.data.serviceType === "former" ? this.props.formerFileFormat :  this.props.fileFormat,
          formerId: this.props.formerId,
          intent: location.state.data && location.state.data.currentIntent === "download" ? "Download" : null,
          serviceType: location.state && location.state.data.serviceType ? location.state.data.serviceType : null,
          uuid: uuid,
        }
        this.props.createFileFormat(fileFormatData).then(() => {
          if (!this.props.error) {
            this.props.history.replace({
              pathname: "verify-identity",
              state: { data: location.state.data }
            });
          }
        })

      }
    })
  };

  render() {
    const { pageContent, loading, location } = this.props;

    if (!pageContent) {
      if (location.state.data.serviceType === "guest") {
        return <Redirect to="/privacy/your-data/guest-landing" />;
      } else if (location.state.data.serviceType === "former") {
        return <Redirect to="/privacy/your-data/former-customer" />;
      }
    }
    if (loading) {
      return <RectangleLoader id="formerLoader" />;
    }
   const serviceType = location.state.data.serviceType;
    return (
      <Fragment>
        <Container>
        <TitleLockup 
              viewport={isMobile ? "mobile": "desktop"}
              surface= 'light'
              textAlignment= 'left'
              data={{                
                 title:{
                  size:'titleXLarge',
                  bold: false,
                  children: convertStringToElements(pageContent.section_title)
                 },
                 subtitle:{
                    size: 'bodyLarge',
                    primitive:'p',
                    children: <Div>{convertStringToElements(pageContent.section_description)}</Div>               
                 }
               }}          
             />
            
          {/* <H1>{convertStringToElements(pageContent.section_title)}</H1>
          <Div>{convertStringToElements(pageContent.section_description)}</Div> */}
          {/* <form onSubmit={this.handleSubmit}> */}
          <fieldset style={{ margin: "32px 0 48px 0" }}>
            <Legend>{pageContent.genericList[0].text}</Legend>
            { serviceType === "guest" ?
              pageContent.genericList[0].list.map(item => (
              <div key={item.jsonKey} style={{ marginBottom: "24px" ,marginLeft: "20px"}}>
                <RadioButton
                  name="fileFormat"
                  value={item.uniqueId}
                  children={<span style={{marginLeft:"-28px"}}>{item.jsonKey}</span>}
                  onChange={this.props.handleRadioChange}
                  selected={item.uniqueId === this.props.fileFormat}
                />                 
              </div>
            )) : 
            pageContent.genericList[0].list.map(item => (
              <div key={item.jsonKey} style={{ marginBottom: "24px" ,marginLeft: "20px"}}>
                <RadioButton
                  name="formerFileFormat"
                  value={item.uniqueId}
                  children={<span style={{marginLeft:"-28px"}}>{item.jsonKey}</span>}
                  onChange={this.props.handleRadioChange}
                  selected={item.uniqueId === this.props.formerFileFormat}
                />                 
              </div>
            ))
          }
          </fieldset>
          <Button onClick={this.handleSubmit} type="submit" background={pageContent.buttons[0].type}>
            {pageContent.buttons[0].text}
          </Button>
          {/* </form> */}
        </Container>
        {this.props.error ? (
          <Alert alertType="error">{convertStringToElements(this.props.error)}</Alert>
        ) : null}
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  pageContent: { "file_format": pageContent },
  downloadInputInformation: { fileFormat, formerFileFormat },
  caseCreation: { caseId },
  formerCustomer: { formerId, accountInfo },
  loadingAndErrorState,
  getUuid: { uuid },
}) => ({
  pageContent,
  loading: loadingAndErrorState.loading,
  error: loadingAndErrorState.error,
  fileFormat,
  formerFileFormat,
  caseId,
  formerId,
  accountInfo,
  uuid,
});

FileFormatSelection.propTypes = {
  handleRadioChange: PropTypes.func.isRequired,
  setA11yContent: PropTypes.func.isRequired,
  pageContent: PropTypes.object.isRequired
};

export default compose(
  connect(
    mapStateToProps,
    {
      setA11yContent,
      handleRadioChange,
      createUpdateProfile,
      createFileFormat,
    }),
  FetchPageContent
)(FileFormatSelection);

const Div = styled.div`
  max-width: 596px;
  p {
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 18px;
  }

  p:first-of-type {
    font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    color: #6F7171;
    margin-bottom:28px;
  }
`;

const Legend = styled.legend`
  font-size: 16px;
  line-height: 20px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  margin-bottom: 24px;
  font-weight: 700;
`;

const H1 = styled.h1`
  font-size: 48px;
  line-height: 48px;
  width: 596px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 300;
  width: 596px;
  margin-bottom: 16px;


  ${media.mobile`
    max-width: 100%;
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    line-height: 36px;
    font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
`}
`;

const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
  margin: "0";
  padding: 48px 16px ;
  `}
`;